<template>
  <div class="">
    <template v-if="!file">
      <form enctype="multipart/form-data" novalidate>
        <div class="dropbox bg-bg"
             @drop.prevent="drop"
             @dragover.prevent="dragover"
             @dragleave.prevent="dragleave">
          <input type="file" id="file" ref="file" name="report"
                 @change.prevent="handleFileUpload"
                 accept=".csv, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
          <div class="flex items-center text-md relative z-60">
            <IconFileUpload class="text-border-hover mr-8"/>
            <p>{{ $t('fileTipText') }}
              <span class="text-red transition duration-200 cursor-pointer
                              border-b border-dashed border-border-hover hover:border-red "
                    @click="$refs.file.click()">
                            {{ $t('chooseFileLabel') }}
              </span>
            </p>
          </div>
        </div>
      </form>
    </template>
    <template v-else>
      <FileDisplay :file="file" @remove="file=''"/>
      <div class="space-x-4 mt-6">
        <BaseButton class="col-span-1"
                    theme="red" size="sm"
                    @click="importFile"
                    :loading="submitted">
          {{ $t('uploadLabel') }}
        </BaseButton>
        <BaseButton class="col-span-1"
                    theme="default" size="sm"
                    @click="file = ''"
                    :loading="submitted">
          {{ $t('anotherFileLabel') }}
        </BaseButton>
      </div>
    </template>
    <HowGetReportInfo class="mt-10" ref="report-info"/>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import IconQuestionMark from "@/components/icons/IconQuestionMark";
import IconChevronSm from "@/components/icons/IconChevronSm";
import HowGetReportInfo
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/HowGetReportInfo/HowGetReportInfo";
import FileDisplay from "@/components/cabinet/Investments/modals/ImportPortfolioModal/FileDisplay";
import IconFileUpload from "@/components/icons/FileIcons/IconFileUpload";
import {mapActions, mapState} from "vuex";

export default {
  name: "ImportPortfolioStep1",
  components: {IconFileUpload, FileDisplay, HowGetReportInfo, IconChevronSm, IconQuestionMark, BaseButton},
  data() {
    return {
      submitted: false,
      file: null
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['current_portfolio'])
  },
  methods: {
    ...mapActions('investments/portfolios', ['uploadPortfolio']),
    dragover(event) {
      // Emulate hover style
      if (event.currentTarget.classList.contains('bg-bg')) {
        event.currentTarget.classList.remove('bg-bg');
        event.currentTarget.classList.add('bg-block-secondary');
      }
    },
    dragleave(event) {
      // Clean up hover style
      event.currentTarget.classList.add('bg-bg');
      event.currentTarget.classList.remove('bg-block-secondary');
    },
    drop(event) {
      this.$refs.file.files = event.dataTransfer.files;
      this.handleFileUpload()
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    importFile() {
      let formData = new FormData();
      formData.append('report', this.file);
      formData.append('portfolio_id', this.current_portfolio.data.id);

      this.submitted = true;
      this.uploadPortfolio(formData)
          .then(res => {
            if (res.body.success) {
              this.$emit('upload', res.body.data)
              this.submitted = false;
            } else {
              this.submitted = false
              this.$toasted.error('Произошла ошибка')
            }
          })
          .catch(e => {
            this.submitted = false
            this.$toasted.error('Произошла ошибка')
          })
    },
    resetFields() {
      this.file = null
      this.submitted = false
    }
  },
  i18n: {
    messages: {
      en: {
        fileTipText: 'Drag and drop file to upload directly here, or',
        chooseFileLabel: 'Choose file',
        uploadLabel: 'Upload report',
        anotherFileLabel: 'Choose another file',
      },
      ru: {
        fileTipText: 'Перетащите файл выгрузки прямо сюда, либо',
        chooseFileLabel: 'Выберите файл',
        uploadLabel: 'Загрузить отчет',
        anotherFileLabel: 'Выбрать другой файл',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dropbox {
  @apply text-text-label transition duration-200 p-4 relative cursor-pointer
  flex items-center justify-center;
  outline: 2px dashed var(--border-hover);
  outline-offset: -5px;
  min-height: 70px;

  &:hover {
    @apply bg-block-secondary;
  }

  input {
    @apply opacity-0 w-full h-full absolute cursor-pointer z-60;
  }
}
</style>